<template>
	<div>
		<div v-show="showAlert" class="alert alert-info">
			<span>Appointment {{ appointment.appointment_status.name }}</span>
		</div>
	
		<div class="card">
			<div class="card-header d-flex justify-content-between align-items-center">
				<h1 class="mb-0 fs-4">
					<a :href="'/participants/'+appointment.attendee.id">{{ appointment.attendee.full_name }} ({{ appointment.attendee.id }})</a> 
					<span class="fs-5">-
					{{ appointment.task ? appointment.task.task_type_status.task_type.name : appointment.appointment_type.name }}</span>
				</h1>
				<div>
					<a :href="'/appointments/'+appointment.id+'/edit'" class="btn btn-outline-secondary btn-sm" role="button">Edit Appointment</a>
				</div>
			</div>
			<div class="card-body">
				<dl class="row">
					<dt class="col-sm-3">Date/Time:</dt>
					<dd class="col-sm-9">{{ appointment.start_date }} at {{ appointment.start_time }}</dd>

					<dt class="col-sm-3">Location:</dt>
					<dd class="col-sm-9">{{ appointment.appointment_location.name }} {{ appointment.location_other ? ' - '+ appointment.location_other : '' }}</dd>

					<dt class="col-sm-3">Interview:</dt>
					<dd class="col-sm-9">{{ appointment.staff.full_name }}</dd>

					<dt class="col-sm-3">Clinician:</dt>
					<dd class="col-sm-9">{{ appointment.clinician ? appointment.clinician.full_name : '&nbsp;' }}</dd>

					<dt class="col-sm-3">Transportation:</dt>
					<dd class="col-sm-9">{{ appointment.transportation ?? '&nbsp;' }}</dd>

					<dt class="col-sm-3">Status:</dt>
					<dd class="col-sm-9">{{ appointment.appointment_status.name }}</dd>

					<dt class="col-sm-3">Notes:</dt>
					<dd class="col-sm-9">{{ appointment.notes ?? '&nbsp;' }}</dd>

					<dt class="col-sm-3">Associated Task:</dt>
					<dd class="col-sm-9">
						<span v-if="appointment.check_in_task && appointment.appointment_status.name == 'Scheduled'">
							{{ appointment.check_in_task.task_type_status.task_type.name }} <a class="btn btn-sm btn-primary" :href="'/tasks/'+appointment.check_in_task.id">Start Task</a>
						</span>
					</dd>
				</dl>
				 <div class="form-group row mt-4 pt-3 border-top">
					<div class="justify-content-start d-flex gap-2">
	  					<button v-if="appointment.appointment_type.name != 'Core Visit' && appointment.appointment_type.name != 'Short Visit'" class="btn btn-outline-success me-1" :disabled="this.appointment.appointment_status.name !== 'Scheduled'" @click="updateStatus('attended')">Mark as Attended</button>
	  					<button class="btn btn-outline-secondary me-1" :disabled="this.appointment.appointment_status.name !== 'Scheduled'" @click="updateStatus('missed')">Mark as Missed</button>
	  					<button class="btn btn-outline-danger" :disabled="this.appointment.appointment_status.name !== 'Scheduled'" @click="updateStatus('canceled')">Cancel Appointment</button>
	  				</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "AppointmentDetail",
	props: {
		appt: Object
	},
	data() {
		return {
			appointment: this.appt,
			showAlert: false
		}
	},
	methods: {
		updateStatus(statusSlug) {
			let confirmationMessage = 'You are about to mark as '+statusSlug+' '+this.appointment.appointment_type.name+' with '+this.appointment.attendee.full_name+' scheduled for '+this.appointment.start_date+' at '+this.appointment.start_time+'. Are you sure you want to continue?'
			if(confirm(confirmationMessage)) {
				let url = '/api/appointments/'+this.appointment.id+'/updateStatus'
				let formData = new FormData()
				formData.append('status', statusSlug)

				axios.post(url, formData)
		            .then((response) => {
		                this.appointment = response.data
		                this.showAlert = true
		            }).catch((e) => {
		                console.log('error: updateStatus()')
		            })
	        }
		}
	}
}
</script>